<template>
    <div class="container-fluid">
        <!-- TITLE -->
        <div class="mt-2 tabName">
            <h3>{{ $t('create_reservation') }}</h3>
        </div>
        <!-- RESERVATION FORM -->
        <ReservationForm
            :errors="errors"
            :showAddMedicationInitially="showAddMedicationInitially"
            :reservation="reservation"
            submitButtonName="create_reservation"
            @submit="submitReservationForm"
            :key="formKey"
        />
        <modals-container />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createReservation, handleAxiosError } from '@/services/axiosService';
import CreatedReservation from './CreatedReservation';
import ReservationForm from './ReservationForm';

export default {
    components: {
        ReservationForm
    },
    data() {
        return {
            errors: {},
            formKey: 0,
            loaded: false,
            reservation: {
                client: '',
                medications: []
            },
            showAddMedicationInitially: true
        };
    },
    methods: {
        ...mapActions('account', ['logout']),
        // submit reservation form (create reservation, show notification and redirect to index)
        async submitReservationForm() {
            try {
                this.reservation.pin = await createReservation(this.reservation);
                this.$toastr.s(this.$t('reservation_created'));
                // show "reservation created" modal
                this.$modal.show(
                    CreatedReservation,
                    { reservation: this.reservation },
                    { height: '200', width: '600', root: this.$root }
                );
            } catch (error) {
                handleAxiosError(error);
                // if backend returns 409 (duplicate) error, show error message under prescription field
                if (error.response.data.status === 409) {
                    this.errors['prescription'] = error.response.data.message;
                }
                this.showAddMedicationInitially = false;
                this.formKey = this.formKey + 1; // update form key for component refresh
            }
        }
    }
};
</script>

<style>
.custom_ul {
    border: 1px solid #ced4da;
    padding-left: 10px;
    list-style: none;
}
.custom_ul li {
    cursor: pointer;
    line-height: 30px;
}
.custom_ul li:hover {
    color: blue;
}
</style>
